export enum PlaycanvasEvent {
  CoolDown = 'CoolDown',
  CoolDownFirstTime = 'CoolDownFirstTime',
  DragonTutorial1 = 'DragonTutorial1',
  DragonTutorial4 = 'DragonTutorial4',
  EggHasBeenChosen = 'EggHasBeenChosen',
  EggHungry = 'EggHungry',
  EggIsAboutToHatch = 'EggIsAboutToHatch',
  GiveDragonName = 'GiveDragonName',
  MathEnergyTutorial1 = 'MathEnergyTutorial1',
  NextHatchingState1 = 'NextHatchingState1',
  NextHatchingState2 = 'NextHatchingState2',
  NextHatchingState3 = 'NextHatchingState3',
}

export enum PortalEvent {
  DragonTutorial2 = 'DragonTutorial2',
  DragonTutorial3 = 'DragonTutorial3',
  FeedMathEnergyToEggFirstTime = 'FeedMathEnergyToEggFirstTime',
  MathEnergyTutorial2 = 'MathEnergyTutorial2',
}

export enum TentativeEvent {
  GetMathEnergyOrbs = 'GetMathEnergyOrbs',
}

export enum OutfitGender {
  MASCULINE = 'masculine',
  FEMININE = 'feminine',
}

export interface AvatarMetadata {
  avatarUrl: string
  bodyType: string
  outfitGender: OutfitGender
  outfitVersion: number
}

export interface ActivitiesDone {
  activityCategory: string
  activityId: string
  createdAt: string
  id: string
}
export enum PlaycanvasTypes {
  REQUEST = 'request',
  ITEMS = 'items',
  DRAGON = 'dragon',
  EVENT = 'event',
  STATE = 'state',
  ACTION = 'action',
  PURCHASE = 'purchase',
}
export enum PlaycanvasActions {
  HIDE_X = 'hideClosingX',
  SHOW_X = 'showClosingX',
  HIDE_SHOP_BUTTON = 'hideShopButton',
  SHOW_SHOP_BUTTON = 'showShopButton',
  MAKE_AVATAR = 'makeAvatar',
  COLLECT_GEMS = 'collectGems',
  GIVE_KUDOS = 'giveKudos',
  CREATE = 'create',
  EVOLVE = 'evolve',
  EQUIP = 'equip',
  UNEQUIP = 'unequip',
  BUY = 'buy',
  UPGRADE = 'upgrade',
  HIDE_HOMEBASE_TABS = 'hideHomebaseTabs',
  SHOW_HOMEBASE_TABS = 'showHomebaseTabs',
  SELECTED_HOMEBASE_TABS = 'selectedHomebaseTabs',
  OPEN_PAGE = 'openPage',
}

export enum PlaycanvasRequest {
  OPEN_SHOP = 'openShop',
  PET_STATE = 'petState',
  AVATAR_URL = 'avatarUrl',
  BADGE_STATE = 'badgeState',
  ACTIVITIES_DONE = 'activitiesDone',
  LOAD_TEXT = 'loadText',
}
